<template>
  <nav>
    <!-- absolute app -->
    <v-navigation-drawer  
    v-model="drawer"
    width="100%"
    fixed
      bottom
      temporary  permanent  color="white" >
    
      <p class="text-right">
      <v-btn  icon  @click="closemenumainpage">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
       </p>

        <v-row>
         <v-col cols="6" class="text-left px-6" style="align-self: center;">
           <v-icon size="30" color="#205295" @click="$store.state.navMenuMainpage = !$store.state.navMenuMainpage">mdi-chevron-left</v-icon>
          </v-col>
         <v-col cols="6" align="right" class="text-right pr-6" style="align-self: center;">
       <!-- <p class="text-center"> -->
       <!-- <router-link to="/" exact> -->
        <img  src="@/assets/logo.png" alt="" width="40%"  />
      <!-- </router-link>  -->
       <!-- </p> -->
    </v-col>
       </v-row>

         <!-- <v-row class="mt-n6 mb-2">
         <v-col align="left" class="mx-2" >
          <v-icon size="30" color="#205295" @click="$store.state.navMenuMainpage = !$store.state.navMenuMainpage">mdi-chevron-left</v-icon>
          </v-col>
         <v-col align="right" >
         <v-menu >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          height="35"
          width="120"
          max-width="120"
          color="#000000"
          text
          v-bind="attrs"
          v-on="on"
         
        >
            {{ defaultlanguage }}
           <v-icon color="#000000">mdi-chevron-down</v-icon> 
        </v-btn>
      </template>

      <v-list>
        <v-list-item
        v-bind:style="{fontWeight:'500 !important' }"
          v-for="(item,idx) in chooselanguage"
          :key="idx"
          link
           @change="onChange(item.flag)"
        >
        {{ item.full_name }}
        </v-list-item>
      </v-list>
    </v-menu>
    </v-col>
       </v-row> -->

      <v-list class="ma-2">
       <!-- <v-subheader>MENUS  </v-subheader> -->
        <v-list-item-group  v-model="selectedMenu"  active-class="deep-purple--text text--accent-4"  color="primary">
          <v-list-item
            class="tile"
            v-for="([icon, text, route], i) in menus"
            :key="i"
            link
            @click="onClickMenu(route)"
           
          >
            <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === i }">{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>

              <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu === i }">mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      
      <br/>
      
      <!-- class="bottom-menu" -->
        <v-list  class="ma-2">
        <v-list-item-group v-model="selectedMenu2"  active-class="deep-purple--text text--accent-4"  color="primary">
          <v-list-item
            class="tile"
            v-for="([icon, text, route], i) in lg_menu_mainpage_bottom"
            :key="i"
            link
            @click="onClickMenu(route)"
          >
            <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu2 === i }">{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>

              <v-list-item-icon>
              <v-icon color="#205295" :class="{ 'active-icon': selectedMenu2 === i }">mdi-chevron-right</v-icon>
            </v-list-item-icon>
            
          </v-list-item>
        </v-list-item-group>
        

        <!-- change language -->
         <!-- <v-list-item
            class="tile"
            :key="i"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ defaultlanguage }}
                 <v-menu 
    :nudge-width="350"
    offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
        :class="{ 'mt-2': $vuetify.breakpoint.xsOnly }"
          height="35"
          width="120"
          max-width="120"
          color="#000000"
          text
          v-bind="attrs"
          v-on="on"
         
        >
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item,idx) in chooselanguage"
          :key="idx"
          link
           @change="onChange(item.flag)"
        >
        {{ item.full_name }}
        </v-list-item>
      </v-list>
    </v-menu>
              </v-list-item-title>
              
            </v-list-item-content>
                <v-list-item-icon>
              <v-icon color="#000000">mdi-chevron-down</v-icon>
            </v-list-item-icon>
          </v-list-item> -->

      </v-list>

      <br/>

        <v-list class="ma-2">
       <!-- <v-subheader>MENUS  </v-subheader>  v-model="selectedMenu3" -->
        <v-list-item-group active-class="deep-purple--text text--accent-4"  color="primary">
          <v-list-item
            class="tile"
            v-for="([icon, text, route], i) in lg_menu_mainpage_bottom_policy"
            :key="i"
            link
          @click="OpenMenuPolicy(route)"
           
          >
            <v-list-item-icon>
              <v-icon color="#205295">{{ icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>

              <v-list-item-icon>
              <v-icon color="#205295">mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { feature } from "../../services/constants";
import { lg_menu_mainpage } from "../../views/language/lg_menu_mainpage";
import { lg_menu_mainpage_bottom } from "../../views/language/lg_menu_mainpage_bottom";
import { lg_menu_mainpage_bottom_policy } from "../../views/language/lg_menu_mainpage_bottom_policy";

export default {
  name: "MenuMainpage",
  props: [],
  menus: null,
  menus_bottom: null,
  menus_bottom_policy:null,
  menu_All:null,
  defaultlanguage: "",
 data() {
    return {
      selectedMenu: 0,
      selectedMenu2:0,
      selectedMenu3:0,
      drawer: true,
       chooselanguage: [
        { name: "en", flag: "gb",full_name:"ENGLISH" },
        { name: "th", flag: "th",full_name:"THAI" },
      ],
    };
  },
  async beforeCreate() {
     window.scrollTo(0,0);

      if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "THAI";
      }else{
        this.defaultlanguage = "ENGLISH";
      }

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage = lg_menu_mainpage.lg_menu_mainpage_th)
      : (this.lg_menu_mainpage = lg_menu_mainpage.lg_menu_mainpage_en);

          localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage_bottom = lg_menu_mainpage_bottom.lg_menu_mainpage_bottom_th)
      : (this.lg_menu_mainpage_bottom = lg_menu_mainpage_bottom.lg_menu_mainpage_bottom_en);

                localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_menu_mainpage_bottom_policy = lg_menu_mainpage_bottom_policy.lg_menu_mainpage_bottom_policy_th)
      : (this.lg_menu_mainpage_bottom_policy = lg_menu_mainpage_bottom_policy.lg_menu_mainpage_bottom_policy_en);
  },
  mounted() {
    let role = localStorage.getItem("role");
      this.menus = this.lg_menu_mainpage;
      this.menus_bottom = this.lg_menu_mainpage_bottom;
      this.menus_bottom_policy = this.lg_menu_mainpage_bottom_policy;
      this.menu_All = [...this.lg_menu_mainpage,...this.lg_menu_mainpage_bottom,...this.lg_menu_mainpage_bottom_policy];


    //    this.selectedMenu = this.menu_All.findIndex(
    //   (menu) => {
    //     console.log(menu[2]) 
    //     console.log(this.$route.path) 
    //     menu[2] == this.$route.path}
    // );
    this.selectedMenu = this.menus.findIndex(
      (menu) => menu[2] == this.$route.path
    );
    this.selectedMenu2 = this.menus_bottom.findIndex(
      (menu) => menu[2] == this.$route.path
    );
    this.selectedMenu3 = this.menus_bottom_policy.findIndex(
      (menu) => menu[2] == this.$route.path
    );
  },
 
  methods: {
    onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
     this.$store.state.navMenuMainpage = !this.$store.state.navMenuMainpage;
    },
 closemenumainpage(){
  this.$store.state.navMenuMainpage = false;
  },
    onChange(lang) {
      // Do something
      // alert(lang.title);
      // this.defaultlanguage = lang;
      localStorage.setItem(feature.LANGUAGE, lang);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "THAI";
      }else{
        this.defaultlanguage = "ENGLISH";
      }
      // alert(localStorage.getItem(feature.LANGUAGE));
      // console.log("language header : " + localStorage.getItem(feature.LANGUAGE));
      this.$router.go();
    },
    OpenMenuPolicy(route){
      if(route == "secureity-policy"){
      this.$store.state.navMenuMainpage = false;
      this.$store.state.navMenuMainpagePolicy = true;
      }else if(route == "switch-language"){
      this.$store.state.navMenuMainpage = false;
      this.$store.state.navMenuMainpageSwitchLanguage = true;
      }else{

      }
    
    },
  },
 
  watch: {
    $route(to, from) {
      // ชั้นของ Array || menu[2]
      this.selectedMenu = this.menul.findIndex((menu) => menu[2] == to.path);
      this.selectedMenu2 = this.menu_bottom.findIndex((menu) => menu[2] == to.path);
      this.selectedMenu3 = this.menus_bottom_policy.findIndex((menu) => menu[2] == to.path);
    },
  },
  computed: {},
};
</script>

<style scoped>
.bottom-menu {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.v-application .deep-purple--text.text--accent-4 {
    color: #000000 !important;
    /* color: #6200ea !important; */
    caret-color: #6200ea !important;
}
.active-icon {
   color: #000000 !important;
}
</style>
